// extracted by mini-css-extract-plugin
export default {"container":"LY-z","list":"MY-z"};